import {takeEvery} from 'redux-saga/effects'

import {
  GET_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTING,
} from '../../Actions/NotificationSettings/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* notificationSettingsSaga() {
  yield takeEvery(GET_NOTIFICATION_SETTINGS, fetchData)
  yield takeEvery(UPDATE_NOTIFICATION_SETTING, fetchData)
}

export default notificationSettingsSaga
